module.exports = __webpack_public_path__ + "img/diplome-sportif.29f43a6f.jpg";